<div class="ev-card history-panel" data-testid="history-panel-container">
  <div class="history-panel__top">
    <button type="button" class="history-panel__back" data-testid="history-panel-back-btn" (click)="goBack()"
      [attr.aria-label]="languageService.languageJSON.Global_Back">
      <img src="assets/icons/light/ui/back_menu.svg" alt="" />
    </button>
    <h2 class="history-panel__title">{{ languageService.languageJSON.HistoryDialog_Trip || 'Trip' }}</h2>
    <span class="history-panel__top-spacer" aria-hidden="true"></span>
  </div>

  @if (history) {
  <div class="history-trip">
    <div class="history-trip__header">
      <p class="history-trip__route">{{ history.startLocation }} - {{ history.targetLocation }}</p>
      <p class="history-trip__date">{{ history.startTime | date }}</p>
    </div>

    <div class="history-trip__stats">
      <div class="stat-pill">
        <img class="stat-pill__icon"
          [src]="'assets/icons/light/ui/vehicle_settings_icon_range.svg'" />
        <span class="stat-pill__value" [hidden]="settingsService.getUnit().Distance!='metric'">
          {{ history.distance }} km
        </span>
        <span class="stat-pill__value" [hidden]="settingsService.getUnit().Distance!='imperial'">
          {{ (history.distance * 6.21371192)/10 | turnValueIntegerThousands }} mi
        </span>
      </div>

      <div class="stat-pill">
        <img class="stat-pill__icon"
          [src]="'assets/icons/light/ui/trip_icon_total_time.svg'" />
        <span class="stat-pill__value stat-pill__value--time">
          @if (history.totalTime.h) {
            <span>
              {{ history.totalTime.h }}{{ languageService.languageJSON.Unit_Hour_Short }}
              {{ history.totalTime.i }} {{ languageService.languageJSON.Unit_Minute_Short }}
            </span>
          }
          @if (!history.totalTime.h) {
            <span>
              {{ history.totalTime.i }} {{ languageService.languageJSON.Unit_Minute_Short }}
            </span>
          }
        </span>
      </div>

      <div class="stat-pill">
        <img class="stat-pill__icon"
          [src]="'assets/icons/light/ui/vehicle_settings_icon_capacity.svg'" />
        <span class="stat-pill__value" [hidden]="settingsService.getUnit().Distance!='metric'">
          {{ history.avgConsumption }} kWh/100km
        </span>
        <span class="stat-pill__value" [hidden]="settingsService.getUnit().Distance!='imperial'">
          {{ (history.avgConsumption * 16.09344)/10 | turnValueIntegerThousands }} kWh/100mi
        </span>
      </div>

      <div class="stat-pill">
        <img class="stat-pill__icon"
          [src]="'assets/icons/light/ui/trip_icon_total_consumption.svg'" />
        <span class="stat-pill__value">{{ history.totalConsumption }} kWh</span>
      </div>
    </div>
  </div>
  }
</div>
